import { createPortal } from 'react-dom';
import GlobalState from './components/GlobalState';
import Results from './components/Results';
import Filters from './components/Filters';

function App() {
  const filterContainer = document.getElementById('query-filters');
  const filters = filterContainer ? createPortal(<Filters />, filterContainer) : false;

  return (
    <GlobalState>
      { filters }
      <Results />
    </GlobalState>
  );
}

export default App;
